import * as React from "react";

import banner1 from "../../assets/services/banner1.png";
import banner2 from "../../assets/services/banner2.png";
import banner3 from "../../assets/services/banner3.png";

import banner1Icon1 from "../../assets/services/5.png";
import banner1Icon2 from "../../assets/services/6.png";
import banner1Icon3 from "../../assets/services/7.png";
import banner1Icon4 from "../../assets/services/8.png";
import banner1Icon5 from "../../assets/services/9.png";
import banner1Icon6 from "../../assets/services/10.png";
import banner1Icon7 from "../../assets/services/11.png";
import banner1Icon8 from "../../assets/services/12.png";
import banner1Icon9 from "../../assets/services/13.png";

import banner2Incon1 from "../../assets/services/14.png";
import banner2Incon2 from "../../assets/services/2.png";
import banner2Incon3 from "../../assets/services/15.png";
import banner2Incon4 from "../../assets/services/8.png";
import banner2Incon5 from "../../assets/services/10.png";
import banner2Incon6 from "../../assets/services/11.png";

import banner3Icon1 from "../../assets/services/16.png";
import banner3Icon2 from "../../assets/services/17.png";
import banner3Icon3 from "../../assets/services/18.png";
import banner3Icon4 from "../../assets/services/19.png";
import Reveal from "../Reveal";
import { motion } from "framer-motion";

const sectionVariants = {
    offscreen: {
        y: -100, // Initially off-screen
        opacity: 0, // Hidden
    },
    onscreen: {
        y: 0, // Moves to its normal position
        opacity: 1, // Fade in
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8, // Animation duration
        },
    },
};

const sectionTwoVariants = {
    offscreen: {
        y: -100, // Initially off-screen
        opacity: 0, // Hidden
    },
    onscreen: {
        y: 0, // Moves to its normal position
        opacity: 1, // Fade in
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8, // Animation duration
        },
    },
};

const sectionThreeVariants = {
    offscreen: {
        y: -100, // Initially off-screen
        opacity: 0, // Hidden
    },
    onscreen: {
        y: 0, // Moves to its normal position
        opacity: 1, // Fade in
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8, // Animation duration
        },
    },
};

function ServiceBlocks() {
    return (
        <section className="flex justify-center items-center pt-16 w-full max-md:px-5 max-md:mt-10 max-md:max-w-full">
            <div className="flex flex-col w-full max-w-[1120px] max-md:max-w-full">
                {/* First banner */}
                <div className="drop-shadow-xl">
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.7 }}
                    >
                        <div className="flex flex-col flex-wrap justify-center content-start items-center p-4 mt-7  bg-light-indigo rounded-xl w-full max-w-[1120px] max-md:max-w-full">
                            <div className="self-stretch max-md:max-w-full">
                                <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                                    <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                                        <motion.div
                                            variants={sectionVariants}
                                            className="text-lg text-white capitalize max-md:mt-2 max-md:max-w-full">
                                            <span className="text-3xl font-medium capitalize">
                                                Expert Interviews
                                            </span>
                                            <br />
                                            <br />
                                            Direct access to industry experts within 24-48 hours,
                                            ensuring you receive the most current and actionable
                                            insights. Cut through the clutter of market noise with
                                            ease. Our suite of services includes comprehensive online
                                            interviews and face-to-face meetings designed to provide
                                            you with the depth of understanding required to make
                                            informed decisions swiftly.
                                        </motion.div>
                                    </div>
                                    <motion.div
                                        variants={sectionVariants}
                                        className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                                        <img
                                            loading="lazy"
                                            src={banner1}
                                            className="grow w-full aspect-[1.85] object-cover max-md:mt-2 max-md:max-w-full rounded-xl"
                                        />
                                    </motion.div>
                                </div>
                            </div>
                            <div className="mt-4 text-2xl sm:text-3xl font-medium text-white capitalize">
                                Our offering includes
                            </div>
                            <div className="flex flex-col flex-wrap justify-center px-3.5 mt-4 w-full sm:max-w-[1013px] max-md:max-w-full">
                                <div className="flex justify-center sm:justify-start gap-3 text-lg font-medium text-center text-white max-md:flex-wrap">
                                    <motion.div
                                        variants={sectionVariants}
                                        className="flex flex-col justify-center sm:justify-start items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner1Icon1}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            Virtual and face-to-face meetings
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        variants={sectionVariants}

                                        className="flex flex-col items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner1Icon2}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            One-on-one session or a group setting
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        variants={sectionVariants}
                                        className="flex flex-col items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner1Icon3}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            {" "}
                                            Free audio recording & AI transcript
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        variants={sectionVariants}
                                        className="flex flex-col items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner1Icon4}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            Custom recruitment for each project
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        variants={sectionVariants}
                                        className="flex flex-col items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner1Icon5}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            {" "}
                                            Boost pitch credibility: free list of experts
                                        </div>
                                    </motion.div>
                                </div>
                                <div className="self-center mt-4 w-full max-w-[861px] max-md:max-w-full">
                                    <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                                            <motion.div
                                                variants={sectionVariants}
                                                className="flex flex-col items-center grow text-lg font-medium text-center text-white max-md:mt-3">
                                                <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                                    <img
                                                        loading="lazy"
                                                        src={banner1Icon6}
                                                        className="self-center aspect-square w-[84px] shadow-xl"
                                                    />
                                                </div>
                                                <div className="mt-4">
                                                    Post-consultation follow-ups at no extra charge
                                                </div>
                                            </motion.div>
                                        </div>
                                        <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
                                            <motion.div
                                                variants={sectionVariants}
                                                className="flex flex-col items-center grow py-0.5 text-lg font-medium text-center text-white max-md:mt-3">
                                                <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                                    <img
                                                        loading="lazy"
                                                        src={banner1Icon7}
                                                        className="self-center aspect-square w-full h-full"
                                                    />
                                                </div>
                                                <div className="mt-4">
                                                    First 10 minutes free: end call if unsatisfied
                                                </div>
                                            </motion.div>
                                        </div>
                                        <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
                                            <motion.div
                                                variants={sectionVariants}
                                                className="flex flex-col items-center grow px-2 py-px text-lg font-medium text-center text-white max-md:mt-3">
                                                <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                                    <img
                                                        loading="lazy"
                                                        src={banner1Icon8}
                                                        className="self-center aspect-square w-full h-full"
                                                    />
                                                </div>
                                                <div className="mt-4">
                                                    Pre-reads can be shared for expert prep
                                                </div>
                                            </motion.div>
                                        </div>
                                        <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
                                            <motion.div
                                                variants={sectionVariants}
                                                className="flex flex-col items-center px-3 py-0.5 text-lg font-medium text-center text-white max-md:mt-3">
                                                <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                                    <img
                                                        loading="lazy"
                                                        src={banner1Icon9}
                                                        className="self-center aspect-square w-full h-full"
                                                    />
                                                </div>
                                                <div className="mt-4">Flexible call durations</div>
                                            </motion.div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* Second banner */}
                <div className="drop-shadow-xl">
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.7 }}
                    >
                        <div className="flex flex-col flex-wrap justify-center content-start items-center p-4 mt-7  bg-dark-indigo rounded-xl drop-shadow-2xl w-full max-w-[1120px] max-md:max-w-full">
                            <div className="self-stretch max-md:max-w-full">
                                <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                                    <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                                        <motion.div className="text-lg text-white capitalize max-md:mt-2 max-md:max-w-full"
                                            variants={sectionTwoVariants}
                                        >
                                            <span className="text-2xl sm:text-3xl font-medium capitalize">
                                                Expertefy-led Calls
                                            </span>
                                            <br />
                                            <br />
                                            We can moderate expert interviews on your behalf.
                                            Following each interview, we provide you with manual
                                            transcript and audio recording of the interview, capturing
                                            the essence of the expert's insights and allowing you to
                                            revisit the discussion at your convenience. This service
                                            is crafted to save you time and resources and to help you
                                            tackle the complexities of language and compliance.
                                        </motion.div>
                                    </div>
                                    <motion.div
                                        variants={sectionTwoVariants}
                                        className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                                        <img
                                            loading="lazy"
                                            src={banner2}
                                            className="grow w-full aspect-[1.85] max-md:mt-2 max-md:max-w-full rounded-xl"
                                        />
                                    </motion.div>
                                </div>
                            </div>
                            <div className="mt-4 text-2xl sm:text-3xl font-medium text-white capitalize">
                                Our offering includes
                            </div>
                            <div className="flex flex-col flex-wrap justify-center content-start px-3.5 mt-4 w-full">
                                <div className="flex justify-center sm:justify-start gap-5 text-lg font-medium text-center text-white max-md:flex-wrap">
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                                        viewport={{ once: true }}
                                        className="flex flex-col items-center px-2 max-md:px-10">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner2Incon1}
                                                className="self-center aspect-square w-[84px] shadow-xl"
                                            />
                                        </div>
                                        <div className="mt-4">Interview content translation</div>
                                    </motion.div>
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                                        viewport={{ once: true }}
                                        className="flex flex-col items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner2Incon2}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            One-on-one session or a group setting
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                                        viewport={{ once: true }}

                                        className="flex flex-col items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner2Incon3}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            {" "}
                                            Audio recording & manual transcript{" "}
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                                        viewport={{ once: true }}

                                        className="flex flex-col items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner2Incon4}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            Custom recruitment for each project
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                                        viewport={{ once: true }}

                                        className="flex flex-col items-center px-2">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner2Incon5}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            {" "}
                                            Post-consultation follow-ups at no extra charge
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                                        viewport={{ once: true }}
                                        className="flex flex-col items-center px-2 max-md:px-16">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] bg-white p-3 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner2Incon6}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4"> Flexible call durations</div>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
                {/* Third banner */}
                <div className="drop-shadow-xl">
                    <motion.div
                        initial={{ opacity: 0, translateX: -200 }}
                        whileInView={{ opacity: 1, translateX: 0 }}
                        transition={{ duration: 0.8, delay: 0.8, type: "spring" }}
                        viewport={{ once: true }}
                    >
                        <div className="flex flex-col flex-wrap justify-center content-start items-center p-4 mt-7  bg-light-indigo rounded-xl drop-shadow-2xl w-full max-w-[1120px] max-md:max-w-full lg:mb-32 max-md:mb-16">
                            <div className="self-stretch max-md:max-w-full">
                                <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                                    <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                                        <motion.div className="text-lg text-white capitalize max-md:mt-2 max-md:max-w-full"
                                            initial={{ opacity: 0, translateX: -200 }}
                                            whileInView={{ opacity: 1, translateX: 0 }}
                                            transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                                            viewport={{ once: true }}
                                        >
                                            <span className="text-2xl sm:text-3xl font-medium capitalize">
                                                B2B Surveys
                                            </span>
                                            <br />
                                            <br />
                                            We offer a robust B2B Survey service that creates and
                                            distributes custom surveys, collecting high quality data
                                            from targeted stakeholders and decision-makers tailored to
                                            your specific research needs.
                                        </motion.div>
                                    </div>
                                    <motion.div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full"
                                        initial={{ opacity: 0, translateX: 200 }}
                                        whileInView={{ opacity: 1, translateX: 0 }}
                                        transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                                        viewport={{ once: true }}  >
                                        <img
                                            loading="lazy"
                                            src={banner3}
                                            className="grow w-full aspect-[1.85] max-md:mt-2 max-md:max-w-full rounded-xl"
                                        />
                                    </motion.div>
                                </div>
                            </div>
                            <div className="mt-4 text-2xl sm:text-3xl font-medium text-white capitalize">
                                Our offering includes
                            </div>
                            <div className="flex flex-col flex-wrap justify-center px-3.5 mt-4 w-full">
                                <div className="flex gap-5 text-lg font-medium text-center text-white max-md:flex-wrap md:max-w-[768px] mx-auto">
                                    <div className="flex w-1/4 flex-col items-center px-2 max-md:w-full">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] h-[84px] bg-white p-4 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner3Icon1}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">Programming & Hosting</div>
                                    </div>
                                    <div className="flex w-1/4 flex-col items-center px-2 max-md:w-full">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] h-[84px] bg-white p-4 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner3Icon2}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">Qualitative & quantitative</div>
                                    </div>
                                    <div className="flex w-1/4 flex-col items-center px-2 max-md:w-full">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] h-[84px] bg-white p-4 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner3Icon3}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">Flexible length</div>
                                    </div>
                                    <div className="flex w-1/4 flex-col items-center px-2 max-md:w-full">
                                        <div className="flex items-center justify-center w-[84px] h-[84px] h-[84px] bg-white p-4 rounded-md custom-shadow">
                                            <img
                                                loading="lazy"
                                                src={banner3Icon4}
                                                className="self-center aspect-square w-full h-full"
                                            />
                                        </div>
                                        <div className="mt-4">Support for native languages</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}

export default ServiceBlocks;
